import { Card, HeadsetIcon, Heading, Icon, Pane, Paragraph, Text, majorScale } from 'evergreen-ui'
import React, { FC } from 'react'
import { Helmet } from 'react-helmet-async'
import { CONSTANTS } from '../../constants'
import { useAppSelector } from '../../hooks'
import { User } from '../../types'
import { generatePageTitle } from '../../utils/generate-page-title'
import styles from './PodcastsPage.module.scss'

interface PodcastsPageProps {
  flex?: number
}

const PodcastsPage: FC<PodcastsPageProps> = (props: PodcastsPageProps) => {
  const title = generatePageTitle(CONSTANTS.TITLES.PODCASTS)

  const user: User | undefined = useAppSelector((state) => state.auth.user)
  const isPreviewUser =
    user?.email !== undefined &&
    CONSTANTS.PODCASTS.PREVIEW_USERS.includes(user.email.toLowerCase())

  return (
    <Pane
      flex={props.flex ?? 1}
      className={styles.PodcastsPage}
      data-testid="PodcastsPage"
      padding={majorScale(4)}
      background="tint2"
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Card
        border="default"
        padding={majorScale(2)}
        display="flex"
        flexDirection="column"
        background="white"
      >
        <Heading size={800} marginBottom={majorScale(1)}>
          Podcasts
        </Heading>
        {isPreviewUser ? (
          <Pane
            display="flex"
            flexDirection="column"
            alignItems="center"
            padding={majorScale(6)}
          >
            <Icon icon={HeadsetIcon} size={40} color="muted" marginBottom={majorScale(2)}></Icon>
            <Paragraph size={500} textAlign="center">
              No episodes have been published yet. Episodes added here will be
              visible to all subscribers once the Podcasts page launches.
            </Paragraph>
          </Pane>
        ) : (
          <Pane
            display="flex"
            flexDirection="column"
            alignItems="center"
            padding={majorScale(6)}
          >
            <Icon icon={HeadsetIcon} size={40} color="muted" marginBottom={majorScale(2)}></Icon>
            <Heading size={600} marginBottom={majorScale(1)}>
              Coming Soon
            </Heading>
            <Text size={500} textAlign="center">
              We're working on bringing you podcasts. Check back soon!
            </Text>
          </Pane>
        )}
      </Card>
    </Pane>
  )
}

export default PodcastsPage
